<mat-chip-list cdkDropList
               [cdkDropListOrientation]="'horizontal'"
               [cdkDropListDisabled]="disabled"
               (cdkDropListDropped)="setNewChipOrder($event)">
    <mat-chip cdkDrag
              class="smp-drag-n-drop-chip"
             *ngFor="let chip of chipsElements; let idx = index"
              id="{{idPrefix}}chip_{{idx}}"
             [selectable]="false"
             [selected]="true"
             [ngClass]="{ 'mat-primary': !disabled }"
             [removable]="!chip.notRemovable"
             (removed)="removeElement(chip)">
        {{ (chip.displayName | translate) || chip.displayName }}
        <mat-icon id="{{idPrefix}}chip_{{idx}}.btn_remove" matChipRemove *ngIf="!chip.notRemovable && !disabled">cancel</mat-icon>
    </mat-chip>

    <mat-select id="{{idPrefix}}input_select.add"
                class="drag-n-drop-chips-selector mat-chip mat-standard-chip"
                [(ngModel)]="selectSelection"
                placeholder="{{ selectionListLabel | translate }}"
                (selectionChange)="addElement()"
                [disabled]="disabled">
        <mat-option *ngFor="let selectableChip of selectionList; let idx = index"
                    id="{{idPrefix}}input_select.ad.option_{{idx}}"
                    [value]="selectableChip">
            {{ (selectableChip.displayName | translate) || selectableChip.displayName }}
        </mat-option>
    </mat-select>

</mat-chip-list>
